import { useTrackingContext } from '@zapier/toolbox-tracking';
import { TrackEventFn } from './events';
import { isDatadog } from '../../utils/isDatadog';

const noop = () => undefined;
/**
 * Wrap useTrackingContext and expose only the strongly typed trackEvent
 * All trackEvent usages should flow through this rather than using useTrackingContext() directly
 */
export const useTrackEvent = (): TrackEventFn => {
  const { trackEvent } = useTrackingContext();
  if (isDatadog()) {
    return noop;
  }
  return trackEvent;
};
